import { useDivisions } from '@inquiries/-hooks/useDivisions'
import { useMemo } from 'react'

/**
 * 主管部門の ID→名前 マップを生成するフック
 *
 * SearchBox のチップ名前解決で使用されます。GET /api/divisions API から取得します。
 */
export function useInquiryDivisionMap() {
  const { data } = useDivisions()
  return useMemo(() => {
    const map = new Map<number, string>()
    for (const div of data?.divisions ?? []) {
      map.set(div.id, div.short_name ?? div.name)
    }
    return map
  }, [data])
}
